[
  {
    "code": "MG-T",
    "name": "Antananarivo"
  },
  {
    "code": "MG-D",
    "name": "Antsiranana"
  },
  {
    "code": "MG-F",
    "name": "Fianarantsoa"
  },
  {
    "code": "MG-M",
    "name": "Mahajanga"
  },
  {
    "code": "MG-A",
    "name": "Toamasina"
  },
  {
    "code": "MG-U",
    "name": "Toliara"
  }
]